import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './pages/index.tsx'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)